// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Expandable Panel Container */
.expandable-panel {
  margin-bottom: 10px;
}

.expandable-panel.sub-panel {
  background-color: #0288d1; /* Light blue background */
  padding: 5px; /* Smaller size */
}

.expandable-subpanel-button {
  width: 100%;
  text-align: left;
  padding: 5px;
  font-size: 16px;
  background-color: #03a9f4; /* Light blue background */
  border: none;
  cursor: pointer;
  outline: none; /* Removes focus outline */
  transition: background-color 0.3s; /* Smooth transition for hover effect */
}

/* Button for toggling the panel */
.expandable-panel-button {
  width: 100%;
  text-align: left;
  padding: 10px;
  font-size: 16px;
  background-color: #0057a9; /* Light grey for unselected state */
  border: none;
  cursor: pointer;
  outline: none; /* Removes focus outline */
  transition: background-color 0.3s; /* Smooth transition for hover effect */
}

.expandable-subpanel-button:hover{
  background-color: #4fc3f7
}
.expandable-panel-button:hover {
  background-color: #008ef3; /* Darker grey on hover for better interaction feedback */
}

/* Icon before the title, rotates when open */
.expandable-panel-icon {
  margin-right: 10px;
  transition: transform 0.3s; /* Smooth rotation */
}

/* Rotated icon when the panel is open */
.expandable-panel-icon.open {
  transform: rotate(90deg); /* Rotates the arrow to indicate expansion */
}

/* Content area of the panel */
.expandable-panel-content {
  overflow: hidden;
  transition: max-height 0.1s linear, padding 0.1s linear, visibility 0.1s linear;
  max-height: 0; 
  padding: 0 10px; 
  visibility: hidden;
}

.expandable-panel-content.open {
  max-height: 2000px; /* Set to a higher approximate value as needed */
  padding: 10px;
  visibility: visible;
  min-width: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/ExpandablePanel.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,YAAY,EAAE,iBAAiB;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB,EAAE,0BAA0B;EACrD,YAAY;EACZ,eAAe;EACf,aAAa,EAAE,0BAA0B;EACzC,iCAAiC,EAAE,uCAAuC;AAC5E;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,yBAAyB,EAAE,oCAAoC;EAC/D,YAAY;EACZ,eAAe;EACf,aAAa,EAAE,0BAA0B;EACzC,iCAAiC,EAAE,uCAAuC;AAC5E;;AAEA;EACE;AACF;AACA;EACE,yBAAyB,EAAE,yDAAyD;AACtF;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,0BAA0B,EAAE,oBAAoB;AAClD;;AAEA,wCAAwC;AACxC;EACE,wBAAwB,EAAE,4CAA4C;AACxE;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,+EAA+E;EAC/E,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,gDAAgD;EACpE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["/* Expandable Panel Container */\n.expandable-panel {\n  margin-bottom: 10px;\n}\n\n.expandable-panel.sub-panel {\n  background-color: #0288d1; /* Light blue background */\n  padding: 5px; /* Smaller size */\n}\n\n.expandable-subpanel-button {\n  width: 100%;\n  text-align: left;\n  padding: 5px;\n  font-size: 16px;\n  background-color: #03a9f4; /* Light blue background */\n  border: none;\n  cursor: pointer;\n  outline: none; /* Removes focus outline */\n  transition: background-color 0.3s; /* Smooth transition for hover effect */\n}\n\n/* Button for toggling the panel */\n.expandable-panel-button {\n  width: 100%;\n  text-align: left;\n  padding: 10px;\n  font-size: 16px;\n  background-color: #0057a9; /* Light grey for unselected state */\n  border: none;\n  cursor: pointer;\n  outline: none; /* Removes focus outline */\n  transition: background-color 0.3s; /* Smooth transition for hover effect */\n}\n\n.expandable-subpanel-button:hover{\n  background-color: #4fc3f7\n}\n.expandable-panel-button:hover {\n  background-color: #008ef3; /* Darker grey on hover for better interaction feedback */\n}\n\n/* Icon before the title, rotates when open */\n.expandable-panel-icon {\n  margin-right: 10px;\n  transition: transform 0.3s; /* Smooth rotation */\n}\n\n/* Rotated icon when the panel is open */\n.expandable-panel-icon.open {\n  transform: rotate(90deg); /* Rotates the arrow to indicate expansion */\n}\n\n/* Content area of the panel */\n.expandable-panel-content {\n  overflow: hidden;\n  transition: max-height 0.1s linear, padding 0.1s linear, visibility 0.1s linear;\n  max-height: 0; \n  padding: 0 10px; \n  visibility: hidden;\n}\n\n.expandable-panel-content.open {\n  max-height: 2000px; /* Set to a higher approximate value as needed */\n  padding: 10px;\n  visibility: visible;\n  min-width: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
